import { MapperEntity } from "@bluefalcon/clients-management-client-fetch";

export const mapperEntity: Record<MapperEntity, string> = {
    'book_of_business': 'Book of Business',
    'commission': 'Commission',
};
